// The only active behavior on the landing page: token flip + expanded information panels.
const coin = document.querySelector<HTMLButtonElement>('.coin-wrap.interactive-token');
coin?.addEventListener('click', () => {
  const flipped = coin.getAttribute('aria-pressed') !== 'true';
  coin.classList.toggle('is-flipped', flipped);
  coin.setAttribute('aria-pressed', String(flipped));
});

document.querySelectorAll<HTMLButtonElement>('[data-panel]').forEach(button => {
  button.addEventListener('click', () => (document.getElementById(button.dataset.panel || '') as HTMLDialogElement | null)?.showModal());
});
document.querySelectorAll<HTMLButtonElement>('.panel-close').forEach(button => {
  button.addEventListener('click', () => (button.closest('dialog') as HTMLDialogElement | null)?.close());
});
document.querySelectorAll<HTMLDialogElement>('dialog').forEach(dialog => {
  dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
});
